import { $userPermissions } from '@/modules/auth/store/auth.store';
import { IconProps } from '@consta/uikit/Icon';
import {
  AgroCultIcon,
  AnaliticalMixing,
  CalcIcon,
  CalcIconActive,
  GrainMixCalc,
  Home,
  Logistics,
  ManageGrainWarehouse,
  MegaMix,
  Mixing,
  MixingSimple,
  Order,
  Prices,
  SearchIcon,
  SellerAccount,
  SellerAccountStatic,
  SimpleMix,
  Trades,
} from '@ui/icons';

export const APP_SECTIONS = (permission: {
  mix: boolean;
  calculator: boolean;
  profile: boolean;
  storage: boolean;
}): {
  shortTitle: string;
  title: string;
  description?: string;
  link: string | null;
  hideAtHomePage?: boolean;
  icon: any;
  icon2: any;
  disabled?: boolean;
}[][] => [
  [
    {
      shortTitle: 'Склады',
      title: 'Управление зерновыми складами',
      description: 'В этом разделе вы можете вести учёт зерновых активов',
      link: '/storage',
      icon: Home,
      icon2: ManageGrainWarehouse,
      //disabled: !permission.storage,
    },
    {
      shortTitle: 'Кабинет',
      title: 'Кабинет продавца зерна',
      description: 'Заявки субагентов на покупку зерна',
      link: '/account/seller',
      icon: SellerAccount,
      icon2: SellerAccountStatic,
      //disabled: !permission.profile,
    },
    {
      shortTitle: 'Логистика',
      title: 'Управление логистикой складов',
      description: '',
      link: '/mixing/logistics',
      icon: Logistics,
      icon2: Logistics,
      //disabled: !permission.mix,
      hideAtHomePage: true,
    },
  ],
  [
    {
      shortTitle: 'Стоимость складов',
      title: 'price-without-mix',
      description: '',
      link: '/best-prices',
      icon: Order,
      icon2: Order,
      //disabled: !permission.mix,
      hideAtHomePage: true,
    },
    {
      shortTitle: 'Аналитика',
      title: 'Биржа зерна',
      description:
        'В этом разделе вы сможете увеличить стоимость складских зерновых активов, применяя метод миксования зерна',
      link: '/mixing',
      icon: Mixing,
      icon2: AnaliticalMixing,
      //disabled: !permission.mix,
    },
    {
      shortTitle: 'Рецепты миксования',
      title: 'Рецепты миксования',
      description: '',
      link: '/mixing/recipes-new',
      icon: SimpleMix,
      icon2: SimpleMix,
      //disabled: !permission.mix,
      hideAtHomePage: true,
    },
    {
      shortTitle: 'Сделки',
      title: 'Текущие сделки',
      description: '',
      link: '/offer',
      icon: Trades,
      icon2: Trades,
      hideAtHomePage: true,
      //disabled: PUBLIC_MODE !== 'development',
    },
    {
      shortTitle: 'Оформленные сделки',
      title: 'Оформленные сделки',
      description: '',
      link: '/offer/contracts',
      icon: AgroCultIcon,
      icon2: AgroCultIcon,
      //disabled: !permission.mix,
      hideAtHomePage: true,
    },
  ],
  // {
  //   shortTitle: 'Консервация',
  //   title: 'Консервация зерновых культур',
  //   description: '',
  //   link: '/conservation',
  //   icon: ConservationIcon,
  // },
  // {
  // shortTitle: 'Цены',
  //   title: 'Стоимость складских зерновых активов',
  //   description:
  //     'В этом разделе вы сможете видеть стоимость складских зерновых активов, на основании рыночных цен',
  //   link: '/prices',
  //   icon: Prices,
  // },
  // {
  //   shortTitle: 'Бункер-перегрузчик',
  //   title: 'Калькулятор простых зерновых миксов',
  //   description:
  //     'В этом разделе вы сможете рассчитать выгоду от мискования зерна разных классов',
  //   link: '/mixing-simple',
  //   icon: MixingSimple,
  //   icon2: GrainMixCalc,
  // },

  [
    {
      shortTitle: 'Калькулятор',
      title: 'Калькулятор зерновых миксов',
      description:
        'Калькулятор миксования используется для детальных расчетов по показателям культуры',
      link: '/calculator',
      icon: CalcIcon,
      icon2: GrainMixCalc,
    },
    {
      shortTitle: 'Поиск зерна',
      title: 'search-by-params',
      link: '/search',
      icon: SearchIcon,
      icon2: SearchIcon,
      hideAtHomePage: true,
    },
  ],
];
